import React from "react";
import FAQCard from "../../../../components/FAQCard/FAQCard";
import "../FAQ/FAQ.css";
function FAQ() {
  return (
    <div className="faq-section">
      <p className="faqHeading">FREQUENTLY ASKED QUESTIONS</p>
      <div className="card-section">
        <FAQCard
          quesNo="01"
          ques="How do I create a LoopGem account?"
          ans="You need to click on the top right “wallet” icon and select the wallet of your choice. Currently, we support MetaMask and Wallet Connect."
        />
        <FAQCard
          quesNo="02"
          ques="Which blockchains does LoopGem Support?"
          ans="LoopGem currently supports Ethereum and Polygon blockchains. We are in the process of onboarding more blockchains in the future."
        />
        <FAQCard
          quesNo="03"
          ques="How do I create and sell an NFT on LoopGem?"
          ans="Click Create in the top right corner on LoopGem.com. You'll be taken to the NFT item creation page. This page will allow you to upload your NFT file, name it, add a description, select the blockchain and influencers. Once you are done, click the “Create” button at the bottom. Congrats, you've just made your first NFT that is ready to be sold!
"
        />
        <FAQCard
          quesNo="04"
          ques="How do I promote an NFT on LoopGem?"
          ans="LoopGem can help you in selling your NFT. During the creation flow, you can select a list of influencers and we will reach out to them to help you sell your NFT. 
"
        />
      </div>
    </div>
  );
}

export default FAQ;
